import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponse } from '@core/models/api-response.model';
import { Dropdown } from '@core/models/dropdown.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class MerchantSitesHttpService {

  constructor(private http: HttpClient) { }

  getMerchantSites(): Observable<Dropdown[]> {
    return this.http.get<ApiResponse>(`/merchantsites`).pipe(
      map(res => res.data.rows)
    );
  }

}
